interface PackageFeature {
    title: string          // 主要功能文案
    description?: string   // 描述性文案/补充说明
    icon?: string         // 可选的图标
}

interface PowerInfo {
    amount: number        // 算力数量
    description: string   // 算力描述
    rechargeBonus?: number // 充值赠送比例
    period?: '月' | '年' | '半月'
}

interface Discount {
    enabled: boolean          // 是否开启折扣
    value: number            // 折扣值（比如 6 表示6折）
    label?: string          // 折扣标签文案（如"限时6折"）
    originalPrice: number   // 原价
    discountedPrice: number // 折后价
}

export interface Package {
    id: string
    type: 'free' | 'plus' | 'pro' | 'ultra' | 'team'
    name: string
    period: string
    subTitle?: string
    price: number | null  // 月费价格
    monthlyRenewPrice?: number // 月续费价格信息
    monthlyOriginalPrice?: number // 月续费原价
    yearlyPrice?: number // 年付价格信息
    yearlyOriginalPrice?: number // 年付原价
    discount?: Discount    // 限时折扣信息
    promotion?: string
    description?: string
    monthPower: PowerInfo     // 新增算力信息
    yearlyPower: PowerInfo
    features: PackageFeature[]
    buttonText: string
    buttonStatus: 'default' | 'primary' | 'disabled' | 'renew' | 'upgrade'
}

/**
 * 会员类型枚举（与后端 memberType 一致）
 * 权威来源：所有业务模块统一从此处导入
 */
export enum MemberType {
    FREE = 'free',
    PRO = 'pro',
    PLUS = 'plus',
    ULTRA = 'ultra'
}